import PropTypes from 'prop-types';

export const REWARD_CODES__POST = 'REWARD_CODES__POST';
export const REWARD_CODES__FETCH = 'REWARD_CODES__FETCH';

export const REWARD_CODES__SHAPE_ITEM = PropTypes.shape({
  id: PropTypes.number,
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  state: PropTypes.string,
  provider: PropTypes.string,
  amount: PropTypes.number,
  immediate: PropTypes.bool,
});

export const REWARD_CODES__SHAPE_ARRAY = PropTypes.arrayOf(REWARD_CODES__SHAPE_ITEM);
